export default "__VITE_ASSET__MGU_xYz4__"